/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-1ec078b3.mjs';
import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { defineComponent, toRefs, provide, reactive, ref, createVNode, mergeProps, computed } from 'vue';
import { i as isObject_1 } from '../_chunks/dep-3ced59c9.mjs';
import props from './props.mjs';
import stepItemProps from './step-item-props.mjs';
import _StepItem from './step-item.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import useVModel from '../hooks/useVModel.mjs';
import '../hooks/index.mjs';
import { useChildComponentSlots } from '../hooks/slot.mjs';
import '../_chunks/dep-558fadc3.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-1c40d002.mjs';
import 'tdesign-icons-vue-next';
import '../hooks/useGlobalIcon.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import '../hooks/icon.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Steps = defineComponent({
  name: "TSteps",
  props: _objectSpread({}, props),
  setup: function setup(props2) {
    var COMPONENT_NAME = usePrefixClass("steps");
    var _toRefs = toRefs(props2),
      current = _toRefs.current,
      modelValue = _toRefs.modelValue;
    var _useVModel = useVModel(current, modelValue, props2.defaultCurrent, props2.onChange, "current"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerCurrent = _useVModel2[0],
      setInnerCurrent = _useVModel2[1];
    provide("StepsState", reactive({
      current: innerCurrent,
      setCurrent: setInnerCurrent
    }));
    provide("StepsProps", props2);
    var indexMap = ref({});
    var handleStatus = function handleStatus(itemProps, index) {
      if (itemProps.status && itemProps.status !== "default") return itemProps.status;
      if (innerCurrent.value === "FINISH") return "finish";
      if (itemProps.value === void 0 && index < innerCurrent.value) return "finish";
      if (itemProps.value !== void 0) {
        var matchIndex = indexMap.value[innerCurrent.value];
        if (matchIndex === void 0) {
          console.warn("TDesign Steps Warn: The current `value` is not exist.");
          return "default";
        }
        if (props2.sequence === "positive" && index < matchIndex) return "finish";
        if (props2.sequence === "reverse" && index > matchIndex) return "finish";
      }
      var key = itemProps.value === void 0 ? index : itemProps.value;
      if (key === innerCurrent.value) return "process";
      return "default";
    };
    var getChildComponentByName = useChildComponentSlots();
    var getOptionListBySlots = function getOptionListBySlots(nodes) {
      var arr = [];
      nodes === null || nodes === void 0 ? void 0 : nodes.forEach(function (node) {
        var option = (node === null || node === void 0 ? void 0 : node.props) || {};
        var children = node === null || node === void 0 ? void 0 : node.children;
        if (!option && !children) return;
        if (children && isObject_1(children)) {
          for (var key in children) {
            if (key in stepItemProps && !option[key]) {
              option[key] = children[key];
            }
          }
        }
        props2.sequence === "reverse" ? arr.unshift(option) : arr.push(option);
      });
      return arr;
    };
    var getOptions = function getOptions() {
      var _props2$options;
      var options;
      if ((_props2$options = props2.options) !== null && _props2$options !== void 0 && _props2$options.length) {
        options = props2.sequence === "reverse" ? props2.options.slice().reverse() : props2.options;
      } else {
        var nodes = getChildComponentByName("StepItem");
        options = getOptionListBySlots(nodes);
      }
      (options || []).forEach(function (item, index) {
        if (item.value !== void 0) indexMap.value[item.value] = index;
      });
      return options;
    };
    var renderContent = function renderContent() {
      var options = getOptions();
      return options.map(function (item, index) {
        var stepIndex = props2.sequence === "reverse" ? options.length - index - 1 : index;
        index = item.value !== void 0 ? index : stepIndex;
        return createVNode(_StepItem, mergeProps(item, {
          "index": stepIndex,
          "status": handleStatus(item, index),
          "key": item.value || index
        }), null);
      });
    };
    var handleTheme = function handleTheme() {
      var theme = props2.theme;
      var options = getOptions();
      options.forEach(function (item) {
        if ((item === null || item === void 0 ? void 0 : item.icon) !== void 0) {
          theme = "default";
        }
      });
      return theme;
    };
    var baseClass = computed(function () {
      return [COMPONENT_NAME.value, "".concat(COMPONENT_NAME.value, "--").concat(props2.layout), "".concat(COMPONENT_NAME.value, "--").concat(handleTheme(), "-anchor"), "".concat(COMPONENT_NAME.value, "--").concat(props2.sequence), "".concat(COMPONENT_NAME.value, "--").concat(props2.separator, "-separator")];
    });
    return function () {
      return createVNode("div", {
        "class": baseClass.value
      }, [renderContent()]);
    };
  }
});

export { _Steps as default };
//# sourceMappingURL=steps.mjs.map
